import { Card, Progress } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { contextApp } from "../../firebase/context";
import { getColection } from "../../firebase/fireStore";
import { format } from "date-fns";
import { es } from "date-fns/locale";

const Tareas = () => {
  let history = useHistory();
  const [percent, setPercent] = useState(100);
  const [loading, setLoading] = useState(true);
  const [reminders, setreminders] = useState([]);
  const { usuario } = useContext(contextApp);
  const getProfesionales = async () => {
    const response = (await getColection("Diagnostic")) || [];
    const getdata = response.filter(
      (item) => item.data.emailPaciente === usuario.email
    );
    setreminders(getdata);
  };
  const timeToString = (fecha) => {
    const date = fecha;
    return date.toISOString().split("T")[0];
  };
  useEffect(() => {
    getProfesionales();
  }, [usuario]);

  return (
    <div>
      <div>
        {reminders.map((res) => (
          <div>
            <Card
              style={{ marginTop: "1%", cursor: "pointer" }}
              onClick={() => {
                history.push("/check", {
                  res,
                });
              }}
            >
              <div style={{ display: "flex" }}>
                Recomendaciones de {res.data.namePsicologo} el día{" "}
                {format(
                  new Date(timeToString(res.data.fechaCreada.toDate())),
                  "PPP",
                  {
                    locale: es,
                  }
                )}
              </div>

              <Progress percent={res.data.percentage * 100} />
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Tareas;
